export const WORDS_PER_PAGE = 20;
export const WORDS_PER_GAME = 20;
export const SECONDS_PER_MINUTE = 60;
export const PAGES_PER_GROUP = 30;

export const LEVEL_COLORS: { [key: number]: string } = {
  0: '#ffef62',
  1: '#ffcd38',
  2: '#a2cf6e',
  3: '#33ab9f',
  4: '#6573c3',
  5: '#af52bf',
  6: '#f6685e',
};

export const LIGHT_GREEN = '#00ff000e';
export const LIGHT_RED = '#ff00000e';
